import TagManager from 'react-gtm-module';
import { DeferredEventsClient } from './DeferredEventsClient';
export class GoogleAnalyticsClient extends DeferredEventsClient {
    constructor(id, nonceId) {
        super();
        this.initialized = false;
        this.initialize = () => {
            if (this.id && !this.initialized) {
                TagManager.initialize({
                    gtmId: this.id,
                });
                this.initialized = true;
                this.sendDeferredEvents(this.sendEvent);
            }
        };
        this.sendEvent = ({ category, entity, action }, meta) => {
            if (this.initialized && this.id) {
                TagManager.dataLayer({
                    dataLayer: Object.assign(Object.assign({ event: 'custom_event', event_category: category, event_label: `${category}_${entity}`, event_action: `${category}_${entity}_${action}`, event_value: meta === null || meta === void 0 ? void 0 : meta.value, dimension6: meta === null || meta === void 0 ? void 0 : meta.userId, dimension13: meta === null || meta === void 0 ? void 0 : meta.customerId }, meta), { value: undefined }),
                });
            }
            else {
                this.deferEvent({ category, entity, action }, meta);
            }
        };
        this.pageVisited = () => {
            if (this.initialized && this.id) {
                TagManager.dataLayer({
                    dataLayer: {
                        event: 'page_view',
                        pagePath: window.location.pathname,
                    },
                });
            }
        };
        this.id = id;
        this.nonceId = nonceId;
    }
}
